import { createStyles } from "@mantine/core";
import { pxToRem } from "theme";

export const useStyles = createStyles(() => ({
  navbar: {
    padding: pxToRem[24],
  },
  logo: {
    height: pxToRem[32],
    maxWidth: pxToRem[300],
  },
}));
